export default __webpack_public_path__ + "static/media/finish-enrichment-data-image.8e5e529e.svg";